import {
  SITES_RESET,
  SITE_SENDING,
  SITE_DOWNLOADED,
  SITES_DOWNLOADED,
  SITES_FAILED,
  SITES_PENDING,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  let sites = [];
  let siteIndex = -1;
  switch (action.type) {
    case SITES_RESET:
      return INITIAL_STATE;
    case SITES_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case SITES_DOWNLOADED:
      return {
        error: null,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case SITE_SENDING:
      return {
        ...state,
        sending: true,
      };
    case SITE_DOWNLOADED:
      if (state.content) {
        sites = state.content.slice();
        siteIndex = sites.findIndex((site) => site.id === action.payload.id);
      }
      if (siteIndex === -1) {
        sites.push(action.payload);
      } else {
        sites[siteIndex] = action.payload;
      }
      return {
        error: null,
        pending: false,
        sending: false,
        content: sites,
      };
    case SITES_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/sites/reducers.js